import { render } from "./EventRegistrations.vue?vue&type=template&id=dbf9069a&scoped=true"
import script from "./EventRegistrations.vue?vue&type=script&lang=js"
export * from "./EventRegistrations.vue?vue&type=script&lang=js"

import "./EventRegistrations.vue?vue&type=style&index=0&id=dbf9069a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf9069a"]])

export default __exports__